<template>
  <main>
    <Nav v-show="$route.path !== '/payment' && $route.path !== '/signup' && $route.path !== '/alpha'"/>
    <router-view class="app-router-view"/>
    <Footer v-show="$route.path !== '/payment'" />
    <s-modals-container/>

  </main>
</template>

<script>

import Footer from '@/components/Footer.vue'
import Nav from '@/components/Nav.vue'
import { defineComponent } from 'vue';
import SModalsContainer from "@/components/SModalsContainer.vue";

const app = defineComponent({
  name: 'home',
  components: {
    SModalsContainer,
    Footer,
    Nav
  }
})

export default app

</script>




<style lang="scss">
@import "styles/_variables-colors";
@import "styles/_variables-borders";
@import "styles/_variables-shadows";
@import "styles/_variables-sizes";
@import "styles/_variables-mixins";
@import "styles/_variables-z-index";
@import "styles/_mixins";

@import "styles/fonts.scss";
@import "styles/_global.scss";
@import "styles/_show_hide.scss";
@import "styles/_icons.scss";
@import "styles/_animations.scss";

@import "styles/buttons.scss";
@import "styles/components.scss";
@import "styles/signupform-comp.scss";
@import "styles/nav-comp.scss";
@import "styles/footer-comp.scss";
@import "styles/modal.scss";
@import "styles/home-feature-comp.scss";
@import "styles/home-hero-comp.scss";
@import "styles/home-plans-container.scss";
@import "styles/home-plans-comp.scss";
@import "styles/home-testimonials2-comp.scss";
@import "styles/home-promotion-comp.scss";
@import "styles/home-subscribe-form.scss";
@import "styles/pages/home-page.scss";
@import "styles/pages/pricing-page.scss";
@import "styles/pricing-plans-container.scss";
@import "styles/pricing-plans-comp.scss";
@import "styles/pages/payment-page.scss";
@import "styles/subscription-plans-container";
@import "styles/pages/about-page.scss";
@import "styles/pages/signup-page.scss";
@import "styles/pages/alpha-page.scss";
@import "styles/pages/contactus-page.scss";
@import "styles/pages/subscribe-page.scss";
</style>
